import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const iconDefaultVars: MotifComponentProps<MotifComponent.ICON> = {
  '--icon-color': m('--foreground-color'),
};
